<div class="modal-header">
  <h4 class="modal-title me-auto" id="modal-basic-title">Change Plan</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCancel()"
  ></button>
</div>
<div class="modal-body pb-0">
  <p>
    You've chosen a {{ packageDisplayName }} plan which doesn't include
    {{ featureText }} you're using:
  </p>

  <ul>
    @for (feature of usedFeaturesNotInPlanDisplay; track feature) {
      <li>
        {{ feature }}
      </li>
    }
  </ul>

  <p>If you continue {{ featureText }} will be disabled.</p>
</div>

<div class="modal-footer">
  @if (!featureIsOnlyInCustomPlan) {
    <button type="button" class="btn btn-outline ms-2" (click)="onCancel()">
      Choose Another Plan
    </button>
  }
  @if (featureIsOnlyInCustomPlan) {
    <button type="button" class="btn btn-outline ms-2" (click)="onCancel()">
      Cancel
    </button>
  }
  <button type="button" class="btn btn-primary" (click)="onUpdate()">
    Continue
  </button>
</div>
